<template>
  <div>
    <div v-if="$device.mobile">
      <MobileGame></MobileGame>
      <MobileRoad></MobileRoad>
      <MobileInside></MobileInside>
      <Details></Details>
      <v-scroll-to-top class="scroll-to-top"></v-scroll-to-top>
    </div>
    <div v-else>
      <DesktopGame></DesktopGame>
    </div>
  </div>
</template>

<script>
import MobileGame from '@/components/MobileGame';
import MobileRoad from '@/components/MobileRoad';
import MobileInside from '@/components/MobileInside';
import Details from '@/components/Details';
import DesktopGame from '@/components/DesktopGame';

export default {
  components: {
    MobileGame,
    MobileRoad,
    MobileInside,
    Details,
    DesktopGame,
  },
};
</script>
